import { useEffect } from 'react';
import { formEventV2 } from '../service/formEventV2';
import { copyToClipboard } from '@/utils/clipboard';

/**
 * 复制成功后的 UI 反馈与埋点：执行复制、1s 后隐藏、上报 popup_codecopy
 */
export function useCopyFeedback(options: {
  /** 是否处于「已复制」展示态 */
  copiedShow: boolean;
  /** 弹窗类型，用于取 POP_WINDOW 的 rules.couponCode 或转盘 couponCode */
  type: string;
  /** 弹窗配置 */
  settings: any;
  /** 转盘等获得的券码 */
  couponCode: string;
  setCopiedShow: (v: boolean) => void;
  triggerEventType: number;
  id: string;
  name: string;
}) {
  const {
    copiedShow,
    type,
    settings,
    couponCode,
    setCopiedShow,
    triggerEventType,
    id,
    name
  } = options;

  useEffect(() => {
    if (!copiedShow) return;

    // 原来只用了老的 web 复制方法，在某些客户网站上有问题
    copyToClipboard(type === 'POP_WINDOW' ? settings?.rules?.couponCode : couponCode);

    const hideTimer = setTimeout(() => setCopiedShow(false), 1000);

    formEventV2({
      event: 'popup_codecopy',
      triggerEventType,
      formId: id,
      formName: name,
      code: type === 'POP_WINDOW' ? settings?.rules?.couponCode : couponCode
    }).catch(() => {});

    return () => clearTimeout(hideTimer);
  // 仅在 copiedShow 为 true 时执行复制与上报
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copiedShow]);
}
